import { render, staticRenderFns } from "./ChatImage.vue?vue&type=template&id=2f4c609b&scoped=true"
import script from "./ChatImage.vue?vue&type=script&lang=js"
export * from "./ChatImage.vue?vue&type=script&lang=js"
import style0 from "./ChatImage.vue?vue&type=style&index=0&id=2f4c609b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c609b",
  null
  
)

export default component.exports